<template>
  <div>
    <div id="gantt-content" class="flex">
      <div id="gantt-task">
        <div id="gantt-task-title" class="flex items-center bg-green-600 text-white h-20" ref="task">
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-48 h-full">タスク
          </div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-date h-full">開始日
          </div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-date h-full flex-col">
            <div>完了</div>
            <div>予定日</div>
          </div>
          <!--          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-date h-full">完了日-->
          <!--          </div>-->
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-20 h-full">ステータス
          </div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-24 h-full">担当
          </div>
        </div>
        <div id="gantt-task-list" class="overflow-y-hidden" :style="`height:${calendarViewHeight}px`">

          <template v-if="applyFilters">
            <div class="flex h-10 border-b">
              <div class="border-r flex items-center font-bold w-48 text-xs pl-4">
                検索
              </div>
              <div class="border-r flex items-center justify-center w-date text-xm flex-col first-filter">
                <YearMonthPicker
                    v-model="selectedStartingYearMonth"
                    title="開始日"
                />
              </div>
              <div class="border-r flex items-center justify-center w-date text-xm flex-col first-filter">
                <YearMonthPicker
                    v-model="selectedEndingYearMonth"
                    title="完了予定日"
                />
              </div>
              <!--              <div class="border-r flex items-center justify-center w-date text-xm flex-col first-filter">-->
              <!--                <YearMonthPicker-->
              <!--                    v-model="selectedCompletionYearMonth"-->
              <!--                    title="完了日"-->
              <!--                />-->
              <!--              </div>-->
              <div class="border-r flex items-center justify-center w-20 text-xm flex-col first-filter">
                <SelectListDialog
                    v-model="selectedStatusId"
                    :select-list="statusTypesList"
                    title="ステータス"
                />
              </div>
              <div class="flex items-center justify-center w-24 text-xm flex-col first-filter">
                <SelectListDialog
                    v-model="selectedUserId"
                    :select-list="usersList"
                    title="担当"
                />
              </div>
            </div>
          </template>

          <div v-for="(task,index) in displayTasks" :key="`tasks-${index}`"
               class="flex h-10 border-b"
               @dragstart="dragTask(task)"
               @dragover.prevent="dragTaskOver(task)"
               :draggable="false"
          >
            <template v-if="task.cat === 'category'">
              <div
                  class="flex items-center font-bold w-full text-sm pl-2 flex justify-between items-center bg-teal-100">
                <span>{{task.name}}</span>
                <div class="pr-4" @click="toggleCategory(task.id)">
                  <span v-if="task.collapsed">
                    <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                  <span v-else>
                    <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </div>
              </div>
            </template>

            <template v-else-if="task.cat === 'category_dates'">
              <div class="flex items-center w-full text-xs pl-4 bg-teal-100">
                <template v-if="task.case_no !== 0 && task.work_days && task.work_days.length > 0">
                  {{ task.work_days.join(', ') }}
                </template>
                <template v-else-if="task.case_no === 0">
                  {{ task.start_date }} ~ {{ task.end_date }}
                </template>
              </div>
            </template>

            <template v-else>
              <div
                  @click="editTask(task)"
                  class="border-r flex items-center font-bold w-48 text-xs pl-4"
                  :class="{'stop-click-event': !clickable}"
                  style="cursor: pointer"
              >
                {{task.F1}}
              </div>
              <div class="border-r flex items-center justify-center w-date text-xs flex-col">
                <div v-if="task.start_date">{{task.start_date.split('-')[0]}}</div>
                <div v-if="task.start_date">{{task.start_date.split('-')[1]}}-{{task.start_date.split('-')[2]}}</div>
              </div>
              <div class="border-r flex items-center justify-center w-date text-xs flex-col">
                <div v-if="task.end_date">{{task.end_date.split('-')[0]}}</div>
                <div v-if="task.end_date">{{task.end_date.split('-')[1]}}-{{task.end_date.split('-')[2]}}</div>
              </div>
              <div class="border-r flex items-center justify-center w-20 text-xs overflow-hidden text-ellipsis">
                {{task.greenc_mst_status_type_name}}
              </div>
              <div class="border-r flex items-center justify-center w-24 text-xs">
                {{task.user_name}}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div id="gantt-calendar" class="overflow-x-scroll overflow-y-hidden border-l"
           :style="`width:${calendarViewWidth}px`" ref="calendar">
        <div id="gantt-date" class="h-20">
          <div id="gantt-year-month" class="relative h-8">
            <div v-for="(calendar,index) in calendars" :key="`dates-${index}`">
              <div
                  class="bg-indigo-700 text-white border-b border-r border-t h-8 absolute font-bold text-sm flex items-center justify-center"
                  :style="`width:${calendar.calendar*block_size}px;left:${calendar.start_block_number*block_size}px`">
                {{calendar.date}}
              </div>
            </div>
          </div>
          <div id="gantt-day" class="relative h-12">
            <div v-for="(calendar,index) in calendars" :key="`date-months-${index}`">
              <div v-for="(day,index) in calendar.days" :key="`month-days-${index}`">
                <div class="border-r border-b h-12 absolute flex items-center justify-center flex-col font-bold text-xs"
                     :class="{'bg-blue-100': day.dayOfWeek === '土' && !formatted_mst_company_calendars[day.fullDate],
                     'bg-red-100': day.dayOfWeek ==='日' && !formatted_mst_company_calendars[day.fullDate],
                     'bg-red-600 text-white': calendar.year=== today.year() && calendar.month === today.month()
                      && day.day === today.date()}"
                     :style="getDayStyle(day, true)"
                     @click="gotToTimeBasedGanttChart(calendar, day)"
                >
                  <span>{{ day.day }}</span>
                  <span>{{ day.dayOfWeek }}</span>
                </div>
              </div>
            </div>
          </div>
          <template v-if="applyFilters">
            <div id="gantt-day-2" class="relative h-10" :style="{zIndex: !showEditDialog ? 10000 : 0}">
              <div v-for="(calendar,index) in calendars" :key="`date-months-${index}`">
                <div v-for="(day,index) in calendar.days" :key="`month-days-${index}`">
                  <div class="border-r border-b h-10 absolute flex items-center justify-center flex-col font-bold text-xs"
                       :class="{'bg-blue-100': day.dayOfWeek === '土', 'bg-red-100': day.dayOfWeek ==='日', 'bg-white': day.dayOfWeek !== '土' && day.dayOfWeek !== '日'}"
                       :style="getDayStyle(day, true)">
                    <template v-if="formatted_mst_company_calendars[day.fullDate] && formatted_mst_company_calendars[day.fullDate].remarks.trim()">
                      <div class="relative group flex items-center justify-center w-full h-full">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-600 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.956 9.956 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm-3 11a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z"/>
                      </svg>
                        <div class="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap hidden group-hover:block z-50 pointer-events-none">
                          {{ formatted_mst_company_calendars[day.fullDate].remarks }}
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div id="gantt-height" class="relative">
            <div v-for="(calendar,index) in calendars" :key="`bottom-month-${index}`">
              <div v-for="(day,index) in calendar.days" :key="`bottom-month-days-${index}`">
                <div class="border-r border-b absolute"
                     :class="{
                      'bg-blue-100': day.dayOfWeek === '土' && !formatted_mst_company_calendars[day.fullDate], 
                      'bg-red-100': day.dayOfWeek ==='日' && !formatted_mst_company_calendars[day.fullDate]
                }"
                     :style="getDayStyle(day)">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="gantt-bar-area" class="relative" :style="`width:${calendarViewWidth}px;height:${calendarViewHeight}px`">
          <!-- Add horizontal grid lines for task rows -->
          <div v-for="(task, index) in displayTasks" :key="`task-grid-${index}`"
               class="absolute"
               :class="{
                 'border-b border-gray-200': task.cat === 'category' || (index < displayTasks.length - 1 && displayTasks[index + 1].cat === 'category'),
                 'border-b': task.cat !== 'category' && !(index < displayTasks.length - 1 && displayTasks[index + 1].cat === 'category'),
                 'border-t border-t-gray-400': task.cat === 'category'
               }"
               :style="`width:${totalCalendarBlocks * block_size}px;height:40px;top:${index * 40 + (applyFilters ? 40 : 0)}px`">
          </div>

          <div v-for="(bar,index) in taskBars" :key="`bar-${bar.task.cat}-${bar.task.id}-${index}`">
            <!-- Task bars (movable) -->
            <div v-if="bar.task.cat === 'task'"
                 :style="bar.style"
                 :class="bar.roundedClass"
                 class="absolute h-5 bg-yellow-500"
                 @mousedown="mouseDownMove(bar.task)">
              <!-- Left resize handle - only show if task starts within visible range -->
              <div v-if="bar.showLeftHandle"
                   class="absolute w-2 h-2 bg-gray-300 border border-black"
                   style="top:6px;left:-6px;cursor:col-resize"
                   @mousedown.stop="mouseDownResize(bar.task,'left')">
              </div>
              <!-- Right resize handle - only show if task ends within visible range -->
              <div v-if="bar.showRightHandle"
                   class="absolute w-2 h-2 bg-gray-300 border border-black"
                   style="top:6px;right:-6px;cursor:col-resize"
                   @mousedown.stop="mouseDownResize(bar.task,'right')">
              </div>
            </div>

            <!-- Category bars (non-movable) -->
            <div v-else-if="bar.task.cat === 'category_dates'"
                 :style="bar.style"
                 :class="bar.roundedClass"
                 class="absolute h-5 bg-purple-500 cursor-default">
              <!-- No resize handles for categories -->
            </div>
          </div>

          <!-- Green bars for children task dates -->
<!--          <div v-for="(childBar, index) in childTaskBars" :key="`child-bar-${index}`">-->
<!--            <div-->
<!--                :style="childBar.style"-->
<!--                class="absolute h-5 bg-green-500"-->
<!--                style="pointer-events: none; z-index: 10;">-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@vuepic/vue-datepicker/dist/main.css'
import YearMonthPicker from '@/components/CDialogCustomYearMonthPIcker.vue'
import SelectListDialog from '@/components/CDialogSelectList.vue'
export default {
  name: 'GanttChart',
  components: {YearMonthPicker, SelectListDialog},
  props: {
    tasksList: {
      type: Array,
      default: () => [],
    },
    block_size: {
      default: 30
    },
    categories: {
      default: []
    },
    clickable: {
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    },
    filterStartDate: {
      type: String,
      default: null,
      validator(value) {
        if (!value) return true;
        const date = new Date(value);
        return !isNaN(date.getTime());
      }
    },
    filterEndDate: {
      type: String,
      default: null,
      validator(value) {
        if (!value) return true;
        const date = new Date(value);
        return !isNaN(date.getTime());
      }
    },
    statusTypesList: {
      type: Array,
      default: () => [],
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    applyFilters: {
      type: Boolean,
      default: false
    },
    showEditDialog: {
      type: Boolean,
      default: false
    },
    mst_company_calendars: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      tasks: [],
      block_number: 0,
      calendars: [],
      inner_width: '',
      inner_height: '',
      task_width: '',
      task_height: '',
      position_id: 0,
      today: this.$moment(),
      dragging: false,
      pageX: '',
      element: '',
      left: '',
      width: '',
      leftResizing: false,
      rightResizing:false,
      task: '',
      selectedStartingYearMonth: '',
      selectedEndingYearMonth: '',
      selectedCompletionYearMonth: '',
      selectedStatusId: '',
      selectedUserId: '',
    }
  },
  methods: {
    gotToTimeBasedGanttChart(targetYm, targetDay) {
      // targetYm.month comes from moment().month() which is 0-based (0 = January).
      // const month = Number(targetYm.month) + 1;
      // const yyyy = String(targetYm.year);
      // const mm = String(month).padStart(2, '0');
      // const dd = String(targetDay.day).padStart(2, '0');
      // const date = `${yyyy}-${mm}-${dd}`;
      // const formattedDate = this.$moment(date).format('YYYY-MM-DD');
      // this.$router.push('/gantt-chart-by-time/' + formattedDate)
    },
    validateFilterDates() {
      if (!this.filterStartDate && !this.filterEndDate) {
        return { isValid: true };
      }

      const startDate = this.filterStartDate ? this.$moment(this.filterStartDate) : null;
      const endDate = this.filterEndDate ? this.$moment(this.filterEndDate) : null;

      // Check if dates are valid
      if (startDate && !startDate.isValid()) {
        return { isValid: false, error: 'Invalid filterStartDate format' };
      }
      if (endDate && !endDate.isValid()) {
        return { isValid: false, error: 'Invalid filterEndDate format' };
      }

      // Check if start date is after end date
      if (startDate && endDate && startDate.isAfter(endDate)) {
        return { isValid: false, error: 'filterStartDate cannot be greater than filterEndDate' };
      }

      return { isValid: true };
    },
    getDays(year, month, block_number) {
      const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
      let days = [];
      let date = this.$moment(`${year}-${month}-01`);
      let num = date.daysInMonth();
      for (let i = 0; i < num; i++) {
        days.push({
          day: date.date(),
          dayOfWeek: dayOfWeek[date.day()],
          block_number,
          fullDate: date.format('YYYY-MM-DD'),
        })
        date.add(1, 'day');
        block_number++;
      }
      return days;
    },
    getCalendar() {
      const validation = this.validateFilterDates();
      if (!validation.isValid) {
        console.warn(`Gantt Chart: ${validation.error}`);
        this.calendars = [];
        return 0;
      }

      let block_number = 0;
      let days;
      let start_month = this.$moment(this.start_month)
      let end_month = this.$moment(this.end_month)
      let between_month = end_month.diff(start_month, 'months')
      this.calendars = []

      // If start month is after end month, don't display any calendars
      if (between_month < 0) {
        return 0;
      }

      for (let i = 0; i <= between_month; i++) {
        days = this.getDays(start_month.year(), start_month.format('MM'), block_number);
        this.calendars.push({
          date: start_month.format('YYYY年MM月'),
          year: start_month.year(),
          month: start_month.month(),
          start_block_number: block_number,
          calendar: days.length,
          days: days
        })
        start_month.add(1, 'months')
        block_number = days[days.length - 1].block_number
        block_number++;
      }
      return block_number;
    },
    getWindowSize() {
      if (this.$refs.task) {
        this.inner_width = window.innerWidth;
        this.inner_height = window.innerHeight;
        this.task_width = this.$refs.task.offsetWidth;
        this.task_height = this.$refs.task.offsetHeight;
      }
    },
    todayPosition() {
      this.$refs.calendar.scrollLeft = this.scrollDistance
    },
    windowSizeCheck() {
      // Smooth virtual scrolling based on how many rows fit in the viewport
      // Account for the filter row occupying one slot when applyFilters is true
      const rowsVisible = Math.floor(this.calendarViewHeight / 40) - (this.applyFilters ? 1 : 0); // 40px per row
      if (event.deltaY > 0) {
        // Scroll down only if there are more rows below the last visible row
        if (this.position_id + rowsVisible < this.lists.length) {
          this.position_id++
        }
      } else if (event.deltaY < 0) {
        // Scroll up if not already at the top
        if (this.position_id > 0) {
          this.position_id--
        }
      }
    },
    mouseDownMove(task){
      // Only allow dragging for tasks, not categories
      if (this.draggable && task.cat !== 'category') {
        this.dragging = true;
        this.pageX = event.pageX;
        this.element = event.target;
        this.left = event.target.style.left;
        this.task_id = task.id
      }
    },
    mouseMove() {
      if (this.dragging) {
        let diff = this.pageX - event.pageX;
        // Proposed new left position
        let proposedLeft = parseInt(this.left.replace('px', '')) - diff;

        // Clamp movement within visible calendar range
        const visibleStart = this.$moment(this.start_month).startOf('month');
        const visibleEnd = this.$moment(this.end_month).endOf('month');
        const totalDays = visibleEnd.diff(visibleStart, 'days') + 1;
        const calendarWidthPx = totalDays * this.block_size;

        const currentWidth = parseInt(this.element.style.width.replace('px', '')) || 0;
        if (proposedLeft < 0) proposedLeft = 0;
        if (proposedLeft > calendarWidthPx - currentWidth) proposedLeft = calendarWidthPx - currentWidth;

        this.element.style.left = `${proposedLeft}px`;
      }
    },
    stopDrag(){
      let taskToEmit = null;
      if (this.dragging) {
        let diff = this.pageX - event.pageX
        let days = Math.ceil(diff / this.block_size)
        if (days !== 0) {
          const task = this.tasks.find(task => task.id === this.task_id);
          const visibleStart = this.$moment(this.start_month).startOf('month');
          const visibleEnd = this.$moment(this.end_month).endOf('month');

          // Original dates
          const origStart = this.$moment(task.start_date);
          const origEffectiveEnd = this.$moment(task.completion_date || task.end_date || task.start_date);
          const duration = origEffectiveEnd.diff(origStart, 'days');

          // Candidate new start (preserve duration)
          let candidateStart = this.$moment(task.start_date).add(-days, 'days');

          // Clamp start so that [newStart, newEnd] stays within visible range
          // newEnd = newStart + duration
          // newStart in [visibleStart, visibleEnd - duration]
          const latestAllowedStart = this.$moment(visibleEnd).add(-duration, 'days');
          let newStart;
          let newEnd;

          if (latestAllowedStart.isBefore(visibleStart, 'day')) {
            // Duration does not fit entirely; clip to visible range
            newStart = this.$moment(visibleStart);
            newEnd = this.$moment(visibleEnd);
          } else {
            // Fit within bounds
            newStart = this.$moment(candidateStart);
            if (newStart.isBefore(visibleStart, 'day')) newStart = this.$moment(visibleStart);
            if (newStart.isAfter(latestAllowedStart, 'day')) newStart = this.$moment(latestAllowedStart);
            newEnd = this.$moment(newStart).add(duration, 'days');
          }

          task['start_date'] = newStart.format('YYYY-MM-DD')
          if (task.completion_date) {
            task['completion_date'] = newEnd.format('YYYY-MM-DD')
          } else {
            task['end_date'] = newEnd.format('YYYY-MM-DD')
          }
          taskToEmit = task
        } else {
          this.element.style.left = `${this.left.replace('px', '')}px`;
        }
      }
      if (this.leftResizing) {
        let diff = this.pageX - event.pageX;
        let days = Math.ceil(diff / this.block_size)
        if (days !== 0) {
          const task = this.tasks.find(task => task.id === this.task_id);
          const visibleStart = this.$moment(this.start_month).startOf('month');
          const hasCompletionDate = !!task.completion_date;
          const hasStartDate = !!task.start_date;
          const hasEndDate = !!task.end_date;

          // Special rule for start-only tasks:
          // expanding/shrinking from the left turns the previous start into end_date.
          if (!hasCompletionDate && hasStartDate && !hasEndDate) {
            const originalStart = this.$moment(task.start_date);
            let candidateStart = this.$moment(task.start_date).add(-days, 'days')
            if (candidateStart.isBefore(visibleStart, 'day')) candidateStart = this.$moment(visibleStart);
            if (candidateStart.isAfter(originalStart, 'day')) candidateStart = this.$moment(originalStart);
            task['start_date'] = candidateStart.format('YYYY-MM-DD')
            task['end_date'] = originalStart.format('YYYY-MM-DD')
            taskToEmit = task
          } else {
            // Candidate new start
            const baseStartDate = task.start_date || task.end_date;
            let candidateStart = this.$moment(baseStartDate).add(-days, 'days')

            // Effective end must not be crossed
            const effectiveEndDate = task.completion_date || task.end_date || task.start_date;
            const end_date = this.$moment(effectiveEndDate)

            // Clamp to visibleStart and not after end_date
            if (candidateStart.isBefore(visibleStart, 'day')) candidateStart = this.$moment(visibleStart);
            if (candidateStart.isAfter(end_date, 'day')) candidateStart = this.$moment(end_date);

            task['start_date'] = candidateStart.format('YYYY-MM-DD')
            taskToEmit = task
          }
        } else {
          this.element.style.width = this.width;
          this.element.style.left = `${this.left.replace('px', '')}px`;
        }
      }
      if (this.rightResizing) {
        let diff = this.pageX - event.pageX;
        let days = Math.ceil(diff / this.block_size)
        if (days === 1) {
          this.element.style.width = `${parseInt(this.width.replace('px', ''))}px`;
        } else if (days <= 2) {
          days--;
          const task = this.tasks.find(task => task.id === this.task_id);
          const visibleEnd = this.$moment(this.end_month).endOf('month');
          const hasCompletionDate = !!task.completion_date;
          const hasStartDate = !!task.start_date;
          const hasEndDate = !!task.end_date;

          // Special rule for end-only tasks:
          // expanding/shrinking from the right turns the previous end into start_date.
          if (!hasCompletionDate && !hasStartDate && hasEndDate) {
            const originalEnd = this.$moment(task.end_date);
            let end_date = this.$moment(task.end_date).add(-days, 'days')
            if (end_date.isBefore(originalEnd, 'day')) end_date = this.$moment(originalEnd)
            if (end_date.isAfter(visibleEnd, 'day')) end_date = this.$moment(visibleEnd)
            task['start_date'] = originalEnd.format('YYYY-MM-DD')
            task['end_date'] = end_date.format('YYYY-MM-DD')
          } else {
            if (task.completion_date) {
              let completion_date = this.$moment(task.completion_date).add(-days, 'days')
              // Clamp: not before start_date, not after visibleEnd
              const start_date = this.$moment(task.start_date)
              if (completion_date.isBefore(start_date, 'day')) completion_date = this.$moment(start_date)
              if (completion_date.isAfter(visibleEnd, 'day')) completion_date = this.$moment(visibleEnd)
              task['completion_date'] = completion_date.format('YYYY-MM-DD')
            } else {
              let end_date = this.$moment(task.end_date || task.start_date).add(-days, 'days')
              const start_date = this.$moment(task.start_date)
              if (end_date.isBefore(start_date, 'day')) end_date = this.$moment(start_date)
              if (end_date.isAfter(visibleEnd, 'day')) end_date = this.$moment(visibleEnd)
              task['end_date'] = end_date.format('YYYY-MM-DD')
            }
          }
          taskToEmit = task
        } else {
          const task = this.tasks.find(task => task.id === this.task_id);
          const visibleEnd = this.$moment(this.end_month).endOf('month');
          const hasCompletionDate = !!task.completion_date;
          const hasStartDate = !!task.start_date;
          const hasEndDate = !!task.end_date;

          // Same special rule for end-only tasks in the larger drag branch.
          if (!hasCompletionDate && !hasStartDate && hasEndDate) {
            const originalEnd = this.$moment(task.end_date);
            let end_date = this.$moment(task.end_date).add(-days, 'days')
            if (end_date.isBefore(originalEnd, 'day')) end_date = this.$moment(originalEnd)
            if (end_date.isAfter(visibleEnd, 'day')) end_date = this.$moment(visibleEnd)
            task['start_date'] = originalEnd.format('YYYY-MM-DD')
            task['end_date'] = end_date.format('YYYY-MM-DD')
            taskToEmit = task
          } else {
            const start_date = this.$moment(task.start_date);

            if (task.completion_date) {
              let completion_date = this.$moment(task.completion_date).add(-days, 'days')
              if (completion_date.isBefore(start_date, 'day')) completion_date = this.$moment(start_date)
              if (completion_date.isAfter(visibleEnd, 'day')) completion_date = this.$moment(visibleEnd)
              task['completion_date'] = completion_date.format('YYYY-MM-DD')
            } else {
              let end_date = this.$moment(task.end_date || task.start_date).add(-days, 'days')
              if (end_date.isBefore(start_date, 'day')) end_date = this.$moment(start_date)
              if (end_date.isAfter(visibleEnd, 'day')) end_date = this.$moment(visibleEnd)
              task['end_date'] = end_date.format('YYYY-MM-DD')
            }
            taskToEmit = task
          }
        }
      }

      if (taskToEmit !== null) {
        this.$emit('taskUpdated', taskToEmit);
      }

      this.dragging = false;
      this.leftResizing = false;
      this.rightResizing = false;
    },
    mouseDownResize(task, direction) {
      // Only allow resizing for tasks, not categories
      if (this.resizable && task.cat !== 'category') {
        direction === 'left' ? this.leftResizing = true : this.rightResizing = true;
        this.pageX = event.pageX;
        this.width = event.target.parentElement.style.width;
        this.left = event.target.parentElement.style.left;
        this.element = event.target.parentElement;
        this.task_id = task.id
      }
    },
    mouseResize() {
      if (this.leftResizing) {
        let diff = this.pageX - event.pageX
        const originalWidth = parseInt(this.width.replace('px', ''))
        let newWidth = originalWidth + diff
        let newLeft = this.left.replace('px', '') - diff

        const visibleStart = this.$moment(this.start_month).startOf('month');
        const visibleEnd = this.$moment(this.end_month).endOf('month');
        const totalDays = visibleEnd.diff(visibleStart, 'days') + 1;
        const calendarWidthPx = totalDays * this.block_size;

        // Minimum width is one block
        if (newWidth < this.block_size) {
          newLeft -= (this.block_size - newWidth);
          newWidth = this.block_size;
        }

        // Prevent left from going out of bounds
        if (newLeft < 0) {
          // Adjust width so the right side stays the same
          newWidth += newLeft; // newLeft is negative
          newLeft = 0;
          if (newWidth < this.block_size) newWidth = this.block_size;
        }

        // Prevent right from exceeding calendar width
        const right = newLeft + newWidth;
        if (right > calendarWidthPx) {
          newWidth = calendarWidthPx - newLeft;
          if (newWidth < this.block_size) newWidth = this.block_size;
        }

        this.element.style.width = `${newWidth}px`
        this.element.style.left = `${newLeft}px`;
      }
      if (this.rightResizing) {
        let diff = this.pageX - event.pageX;
        const visibleStart = this.$moment(this.start_month).startOf('month');
        const visibleEnd = this.$moment(this.end_month).endOf('month');
        const totalDays = visibleEnd.diff(visibleStart, 'days') + 1;
        const calendarWidthPx = totalDays * this.block_size;

        const originalWidth = parseInt(this.width.replace('px', ''))
        let newWidth = originalWidth - diff
        if (newWidth < this.block_size) newWidth = this.block_size;

        // Prevent right edge from exceeding calendar width
        const currentLeft = parseInt(this.left.replace('px', ''))
        if (currentLeft + newWidth > calendarWidthPx) {
          newWidth = calendarWidthPx - currentLeft;
          if (newWidth < this.block_size) newWidth = this.block_size;
        }

        this.element.style.width = `${newWidth}px`
      }
    },
    dragTask(dragTask) {
      this.task = dragTask
    },
    toggleCategory(task_id) {
      let category = this.categories.find(category => category.id === task_id)
      category['collapsed'] = !category['collapsed'];
    },
    editTask(task){
      if (this.clickable) {
        this.$emit('editTask', task)
      }
    },
    dragTaskOver(overTask) {
      if (this.draggable) {
        let deleteIndex;
        let addIndex;
        if (this.task.cat !== 'category') {
          if (overTask.cat === 'category') {
            let updateTask = this.tasks.find(task => task.id === this.task.id)
            updateTask['category_id'] = overTask['id']
          } else {
            if (overTask.id !== this.task.id) {
              this.tasks.map((task, index) => { if (task.id === this.task.id) deleteIndex = index })
              this.tasks.map((task, index) => { if (task.id === overTask.id) addIndex = index })
              this.tasks.splice(deleteIndex, 1)
              this.task['category_id'] = overTask['category_id']
              this.tasks.splice(addIndex, 0, this.task)
            }
          }
        }
      }
    },
    initialize() {
      this.getCalendar()
      this.getWindowSize();
      // this.$nextTick(() => {
      //   this.todayPosition();
      // })
      window.addEventListener('resize', this.getWindowSize);
      window.addEventListener('wheel', this.windowSizeCheck);
      window.addEventListener('mousemove', this.mouseMove);
      window.addEventListener('mouseup', this.stopDrag);
      window.addEventListener('mousemove', this.mouseResize);
    },
    checkDateFilterHasValue(date) {
      return date && "year" in date && date.year;
    },
    getDayStyle(day, forHeader = false) {
      const calendar = this.formatted_mst_company_calendars[day.fullDate]
      const returnData = {
        width: `${this.block_size}px`,
        left: `${day.block_number * this.block_size}px`,
        ...(!forHeader && {height: `${this.calendarViewHeight}px`,}),
        ...(calendar && {
          background: calendar.mst_company_calendar_back_color_code_name
        })
      }
      return returnData
    }
  },
  computed: {
    totalCalendarBlocks() {
      if (this.calendars.length === 0) return 0;

      // Get the last calendar entry
      const lastCalendar = this.calendars[this.calendars.length - 1];
      // Get the last day of the last calendar
      const lastDay = lastCalendar.days[lastCalendar.days.length - 1];
      // Return the block number + 1 (since block_number is 0-indexed)
      return lastDay.block_number + 1;
    },
    calendarViewWidth() {
      return this.inner_width - this.task_width;
    },
    calendarViewHeight() {
      return this.inner_height - this.task_height - 48 - 20;
    },
    scrollDistance() {
      let start_date = this.$moment(this.start_month);
      let between_days = this.today.diff(start_date, 'days')
      return (between_days + 1) * this.block_size - this.calendarViewWidth / 2;
    },
    lists() {
      let lists = [];

      const selected1Ym = this.checkDateFilterHasValue(this.selectedStartingYearMonth);
      const selected2Ym = this.checkDateFilterHasValue(this.selectedEndingYearMonth);
      const selected3Ym = this.checkDateFilterHasValue(this.selectedCompletionYearMonth);

      // Pre-format selected dates if available
      const format1 = selected1Ym ? this.$moment(this.selectedStartingYearMonth).format('YYYY-MM') : null;
      const format2 = selected2Ym ? this.$moment(this.selectedEndingYearMonth).format('YYYY-MM') : null;
      const format3 = selected3Ym ? this.$moment(this.selectedCompletionYearMonth).format('YYYY-MM') : null;

      // Calculate date range filter based on filterStartDate and filterEndDate props
      const filterStart = this.filterStartDate
          ? this.$moment(this.filterStartDate).startOf('month')
          : null;
      const filterEnd = this.filterEndDate
          ? this.$moment(this.filterEndDate).endOf('month')
          : null;

      // Helper function to check if a date range overlaps with filter range
      const overlapsWithFilterRange = (start_date, end_date) => {
        if (!filterStart && !filterEnd) return true;

        const itemStart = this.$moment(start_date);
        const itemEnd = this.$moment(end_date || start_date);

        if (!itemStart.isValid() || !itemEnd.isValid()) return false;

        if (filterStart && filterEnd) {
          return itemStart.isSameOrBefore(filterEnd, 'day') && itemEnd.isSameOrAfter(filterStart, 'day');
        } else if (filterStart) {
          return itemEnd.isSameOrAfter(filterStart, 'day');
        } else if (filterEnd) {
          return itemStart.isSameOrBefore(filterEnd, 'day');
        }
        return true;
      };

      // Helper function to check if any work_days fall within filter range
      const hasWorkDaysInRange = (work_days) => {
        if (!filterStart && !filterEnd) return true;
        if (!work_days || !Array.isArray(work_days) || work_days.length === 0) return false;

        return work_days.some(workDay => {
          const work_date = this.$moment(workDay);
          if (!work_date.isValid()) return false;

          if (filterStart && filterEnd) {
            return work_date.isSameOrAfter(filterStart, 'day') && work_date.isSameOrBefore(filterEnd, 'day');
          } else if (filterStart) {
            return work_date.isSameOrAfter(filterStart, 'day');
          } else if (filterEnd) {
            return work_date.isSameOrBefore(filterEnd, 'day');
          }
          return true;
        });
      };

      // Filter tasks based on selected dates dynamically
      let filteredList = this.tasks.filter(task => {
        const formatStartDate = this.$moment(task.start_date).format('YYYY-MM');
        const formatEndDate = this.$moment(task.end_date).format('YYYY-MM');
        const formatCompletionDate = this.$moment(task.completion_date).format('YYYY-MM');

        return (!format1 || formatStartDate === format1) &&
            (!format2 || formatEndDate === format2) &&
            (!format3 || formatCompletionDate === format3) &&
            (!this.selectedUserId || task.user_id === this.selectedUserId) &&
            (!this.selectedStatusId || task.greenc_mst_status_type_id === this.selectedStatusId)
      });

      // If there are no categories, return tasks directly (filtered by date range)
      if (this.categories.length === 0) {
        return filteredList
            .filter(task => overlapsWithFilterRange(task.start_date || task.end_date, task.completion_date || task.end_date || task.start_date))
            .map(task => ({ cat: 'task', ...task }));
      }

      // Combine categories + tasks
      this.categories.forEach(category => {
        // Check if category has bars in the filter range
        let categoryHasBarsInRange = false;

        if (category.case_no !== 0 && category.work_days && Array.isArray(category.work_days) && category.work_days.length > 0) {
          // Check if any work_days fall within the range
          categoryHasBarsInRange = hasWorkDaysInRange(category.work_days);
        } else if (category.case_no === 0) {
          // Check if category date range overlaps with filter range
          categoryHasBarsInRange = overlapsWithFilterRange(category.start_date, category.end_date);
        }

        // Filter tasks for this category that have bars in the range
        const tasksInCategory = filteredList.filter(task =>
            task.category_id === category.id && overlapsWithFilterRange(task.start_date || task.end_date, task.completion_date || task.end_date || task.start_date)
        );

        // Only show category if it has bars in range OR has tasks with bars in range
        if (categoryHasBarsInRange || tasksInCategory.length > 0) {
          // Add category name row
          lists.push({ cat: 'category', ...category });

          // Add category date display row (always visible, not affected by collapse)
          lists.push({ cat: 'category_dates', ...category });

          // Add tasks that have bars in range (respect collapse state)
          if (!category.collapsed) {
            tasksInCategory.forEach(task => {
              lists.push({ cat: 'task', ...task });
            });
          }
        }
      });

      return lists;
    },
    displayTasks() {
      // Number of rows that can fully fit into the viewport (40px per row)
      // Subtract one when the filter row is shown, because it consumes 40px in the list area
      let display_task_number = Math.floor(this.calendarViewHeight / 40) - (this.applyFilters ? 1 : 0);
      return this.lists.slice(this.position_id, this.position_id + display_task_number);
    },
    taskBars() {
      if (!this.displayTasks || this.displayTasks.length === 0) {
        return [];
      }

      // If no calendars are visible (invalid date range), don't show any task bars
      if (this.calendars.length === 0) {
        return [];
      }

      const start_date = this.$moment(this.start_month).startOf('month');
      const end_date = this.$moment(this.end_month).endOf('month');
      const bars = [];

      this.displayTasks.forEach((task, displayIndex) => {
        if (task.start_date || task.end_date) {
          const task_start_date = this.$moment(task.start_date || task.end_date);

          // For categories with work_days, create individual bars for each work day
          if (task.cat === 'category_dates' && task.case_no !== 0) {
            if (task.work_days && Array.isArray(task.work_days) && task.work_days.length > 0) {
              task.work_days.forEach(workDay => {
                const work_date = this.$moment(workDay);

                if (!work_date.isValid()) {
                  return;
                }

                if (work_date.isBefore(start_date, 'day') || work_date.isAfter(end_date, 'day')) {
                  return;
                }

                if (this.filterStartDate || this.filterEndDate) {
                  const filterStart = this.filterStartDate
                      ? this.$moment(this.filterStartDate, "YYYY-MM").startOf("month")
                      : null;
                  const filterEnd = this.filterEndDate
                      ? this.$moment(this.filterEndDate, "YYYY-MM").endOf("month")
                      : null;

                  let dateInRange = true;

                  if (filterStart && filterEnd) {
                    dateInRange = work_date.isSameOrAfter(filterStart, 'day') && work_date.isSameOrBefore(filterEnd, 'day');
                  } else if (filterStart) {
                    dateInRange = work_date.isSameOrAfter(filterStart, 'day');
                  } else if (filterEnd) {
                    dateInRange = work_date.isSameOrBefore(filterEnd, 'day');
                  }

                  if (!dateInRange) {
                    return;
                  }
                }

                const days_from_start = work_date.diff(start_date, 'days');
                const left = days_from_start * this.block_size;
                const top = 10 + (displayIndex * 40) + (this.applyFilters ? 40 : 0);

                bars.push({
                  style: {
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${this.block_size}px`,
                    background: '#8B5CF6'
                  },
                  task,
                  showLeftHandle: false,
                  showRightHandle: false,
                  roundedClass: 'rounded-lg'
                });
              });
            }
            return; // Skip the rest of the logic for this category
          }

          // For categories without work_days, always use end_date; for tasks, prefer completion_date over end_date
          let effectiveEndDate;
          if (task.cat === 'category_dates') {
            effectiveEndDate = task.end_date;
          } else {
            effectiveEndDate = task.completion_date || task.end_date || task.start_date;
          }

          const task_end_date = this.$moment(effectiveEndDate);

          // Validate dates
          if (!task_start_date.isValid() || !task_end_date.isValid()) {
            return;
          }

          // Check if task overlaps with the visible calendar range
          if (task_end_date.isBefore(start_date, 'day') || task_start_date.isAfter(end_date, 'day')) {
            return; // Task is completely outside the visible range
          }

          // Filter tasks by date range - only show bars for tasks that overlap with filter range
          if (this.filterStartDate || this.filterEndDate) {
            const filterStart = this.filterStartDate
                ? this.$moment(this.filterStartDate, "YYYY-MM").startOf("month")
                : null;
            const filterEnd = this.filterEndDate
                ? this.$moment(this.filterEndDate, "YYYY-MM").endOf("month")
                : null;


            let taskInRange = true;

            if (filterStart && filterEnd) {
              // Task overlaps if: task_start <= filter_end AND task_end >= filter_start
              taskInRange = task_start_date.isSameOrBefore(filterEnd, 'day') && task_end_date.isSameOrAfter(filterStart, 'day');
            } else if (filterStart) {
              // Task must end after or on filter start
              taskInRange = task_end_date.isSameOrAfter(filterStart, 'day');
            } else if (filterEnd) {
              // Task must start before or on filter end
              taskInRange = task_start_date.isSameOrBefore(filterEnd, 'day');
            }

            // Skip this task bar if it's outside the filter range
            if (!taskInRange) {
              return;
            }
          }

          // Calculate visible portion of the task bar
          const visible_start_date = this.$moment.max(task_start_date, start_date);
          const visible_end_date = this.$moment.min(task_end_date, end_date);

          // Calculate position and dimensions for the visible portion
          const visible_between = visible_end_date.diff(visible_start_date, 'days') + 1;

          // Only show if there are visible days
          if (visible_between <= 0) {
            return;
          }

          const visible_start = visible_start_date.diff(start_date, 'days');
          const left = visible_start * this.block_size;
          const top = 10 + (displayIndex * 40) + (this.applyFilters ? 40 : 0);

          // Determine which handles to show
          const showLeftHandle = task_start_date.isSameOrAfter(start_date, 'day');
          const showRightHandle = task_end_date.isSameOrBefore(end_date, 'day');

          // Determine rounded corners - only round the ends that are not cut off
          let roundedClass = '';
          if (showLeftHandle && showRightHandle) {
            // Both ends visible - fully rounded
            roundedClass = 'rounded-lg';
          } else if (showLeftHandle && !showRightHandle) {
            // Only left end visible - round left side only
            roundedClass = 'rounded-l-lg';
          } else if (!showLeftHandle && showRightHandle) {
            // Only right end visible - round right side only
            roundedClass = 'rounded-r-lg';
          }
          // If neither handle is visible, no rounding (straight cut on both sides)

          // Determine bar color based on task type and status
          let backgroundColor;
          if (task.cat === 'category_dates') {
            // Purple color for categories (non-movable)
            backgroundColor = '#8B5CF6'; // purple-500
          } else {
            if (task.greenc_mst_status_type_id === 5) {
              backgroundColor = '#156082'
            }else {
              backgroundColor = '#EAB305'
            }
          }

          let showLeftHandleIcon = false
          let showRightHandleIcon = false
          if (this.resizable) {
            showLeftHandleIcon = task.cat === 'category_dates' ? false : showLeftHandle
            showRightHandleIcon = task.cat === 'category_dates' ? false : showRightHandle
          }

          bars.push({
            style: {
              top: `${top}px`,
              left: `${left}px`,
              width: `${this.block_size * visible_between}px`,
              background: backgroundColor
            },
            task,
            showLeftHandle: showLeftHandleIcon, // No handles for categories
            showRightHandle: showRightHandleIcon, // No handles for categories
            roundedClass
          });
        }
      });

      return bars;
    },
    start_month() {
      const validation = this.validateFilterDates();
      if (!validation.isValid) {
        console.warn(`Gantt Chart: ${validation.error}`);
        // Return current date as fallback
        return this.$moment().format('YYYY-MM');
      }

      // If filterStartDate is provided and valid, use it
      if (this.filterStartDate) {
        const filterStart = this.$moment(this.filterStartDate);
        if (filterStart.isValid()) {
          return filterStart.format('YYYY-MM');
        }
      }

      // If only filterEndDate is provided (and filterStartDate is empty), use filterEndDate
      if (this.filterEndDate && !this.filterStartDate) {
        const filterEnd = this.$moment(this.filterEndDate);
        if (filterEnd.isValid()) {
          return filterEnd.format('YYYY-MM');
        }
      }

      // Otherwise, use the earliest task start date (including categories)
      if (this.tasks.length === 0 && this.categories.length === 0) {
        return this.$moment().format('YYYY-MM');
      }

      const allItems = [...this.tasks, ...this.categories];
      const validStartDates = allItems
          .map(item => new Date(item.start_date))
          .filter(date => !isNaN(date.getTime()));

      if (validStartDates.length === 0) {
        return this.$moment().format('YYYY-MM');
      }

      const earliestStartDate = new Date(Math.min(...validStartDates));
      return this.$moment(earliestStartDate).format('YYYY-MM');
    },
    end_month() {
      const validation = this.validateFilterDates();
      if (!validation.isValid) {
        console.warn(`Gantt Chart: ${validation.error}`);
        // Return current date as fallback
        return this.$moment().format('YYYY-MM');
      }

      // If filterEndDate is provided and valid, use it
      if (this.filterEndDate) {
        const filterEnd = this.$moment(this.filterEndDate);
        if (filterEnd.isValid()) {
          return filterEnd.format('YYYY-MM');
        }
      }

      // If only filterStartDate is provided (and filterEndDate is empty), use filterStartDate
      if (this.filterStartDate && !this.filterEndDate) {
        const filterStart = this.$moment(this.filterStartDate);
        if (filterStart.isValid()) {
          return filterStart.format('YYYY-MM');
        }
      }

      // Otherwise, use the latest task end date (including categories)
      if (this.tasks.length === 0 && this.categories.length === 0) {
        return this.$moment().format('YYYY-MM');
      }

      // For end_month calculation, we need to consider both end_date and completion_date
      const taskEndDates = this.tasks
          .map(task => {
            const endDate = task.completion_date || task.end_date || task.start_date;
            return new Date(endDate);
          })
          .filter(date => !isNaN(date.getTime()));

      // For categories, always use end_date
      const categoryEndDates = this.categories
          .map(category => new Date(category.end_date))
          .filter(date => !isNaN(date.getTime()));

      const allEndDates = [...taskEndDates, ...categoryEndDates];

      if (allEndDates.length === 0) {
        return this.$moment().format('YYYY-MM');
      }

      const latestEndDate = new Date(Math.max(...allEndDates));
      return this.$moment(latestEndDate).format('YYYY-MM');
    },
    childTaskBars() {
      if (!this.displayTasks || this.displayTasks.length === 0) {
        return [];
      }

      // If no calendars are visible (invalid date range), don't show any bars
      if (this.calendars.length === 0) {
        return [];
      }

      const start_date = this.$moment(this.start_month).startOf('month');
      const end_date = this.$moment(this.end_month).endOf('month');
      const childBars = [];

      this.displayTasks.forEach((task, displayIndex) => {
        // Only process tasks (not categories) that have children
        if (task.cat === 'task' && task.children && Array.isArray(task.children) && task.children.length > 0) {

          // Process each child's task_date
          task.children.forEach((child) => {
            if (child.task_date) {
              const child_date = this.$moment(child.task_date);

              // Validate date
              if (!child_date.isValid()) {
                return;
              }

              // Check if child date is within visible calendar range
              if (child_date.isBefore(start_date, 'day') || child_date.isAfter(end_date, 'day')) {
                return;
              }

              // Calculate position for the green bar (single day)
              const days_from_start = child_date.diff(start_date, 'days');
              const left = days_from_start * this.block_size;
              const top = 10 + (displayIndex * 40) + (this.applyFilters ? 40 : 0);

              childBars.push({
                style: {
                  top: `${top}px`,
                  left: `${left}px`,
                  width: `${this.block_size}px`,
                  background: '#16A349' // green-500
                }
              });
            }
          });
        }
      });

      return childBars;
    },
    formatted_mst_company_calendars() {
      const returnData = {};
      this.mst_company_calendars.forEach(calendar => {
        const date = this.$moment(calendar.date).format('YYYY-MM-DD');
        returnData[date] = calendar;
      })
      return returnData
    }
  },
  beforeMount() {
    this.tasks = [...this.tasksList]
  },
  mounted() {
    this.initialize()
  },
  watch: {
    tasksList: {
      handler(newTasks) {
        this.tasks = [...newTasks]
      },
      deep: true,
    },
    start_month(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.initialize()
      }
    },
    end_month(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.initialize()
      }
    },
    filterStartDate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initialize()
      }
    },
    filterEndDate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.initialize()
      }
    }
  }
}
</script>

<style scoped>
.stop-click-event {
  pointer-events: none;
}
.w-date {
  width: 50px;
}
.w-date-1{
  width: 60px;
}
</style>
